import router from "../router";

import {
  requestUpdateObituaryMessage,
  requestObituaryMessageList,
  requestDeleteObituaryMessage
} from "@/apis/obituaryMessage_api";

const state = {
  obituaryMessageDetail: {
    id: null,
    obituaryMessageTitle: null,
    obituaryMessageContent: null,
    obituaryMessageFile: []
  },
  obituaryMessageList: [],
  obituaryMessagePage: null,
  obituaryMessagePageTotal: 0,
  obituaryMessageTotalElemtnts: 0
};

const getters = {
  getObituaryMessageDetail(state) {
    return state.obituaryMessageDetail;
  },
  getObituaryMessageList(state) {
    return state.obituaryMessageList;
  },
  getObituaryMessagePage(state) {
    if (state.obituaryMessagePage === null) {
      return 0;
    } else {
      return state.obituaryMessagePage.pageNumber + 1;
    }
  },
  getObituaryMessagePageTotal(state) {
    return state.obituaryMessagePageTotal;
  },
  getObituaryMessageTotalElements(state) {
    return state.obituaryMessageTotalElemtnts;
  }
};

const mutations = {
  OBITUARY_MESSAGE_DETAIL(state, data) {
    let fileList = [];
    for (
      let index = 0;
      index < data.resultObituaryMessage.obituaryMessageFile.length;
      index++
    ) {
      let file = new File(
        [],
        data.resultObituaryMessage.obituaryMessageFile[index].fileOriginalName,
        {}
      );
      file.id = data.resultObituaryMessage.obituaryMessageFile[index].id;
      file.fileExtension =
        data.resultObituaryMessage.obituaryMessageFile[index].fileExtension;
      file.filePath =
        data.resultObituaryMessage.obituaryMessageFile[index].filePath;
      file.fileSavePath =
        data.resultObituaryMessage.obituaryMessageFile[index].fileSavePath;
      file.fileType =
        data.resultObituaryMessage.obituaryMessageFile[index].fileType;
      fileList.push(file);
    }
    data.resultObituaryMessage.obituaryMessageFile = fileList;
    state.obituaryMessageDetail = data.resultObituaryMessage;
  },
  OBITUARY_MESSAGE_LIST(state, data) {
    state.obituaryMessageList = data.resultObituaryMessageList;
    state.obituaryMessagePage = data.page;
    state.obituaryMessagePageTotal = data.pageTotal;
    state.obituaryMessageTotalElemtnts = data.totalElemtnts;
  }
};

const actions = {
  async REQUEST_REGIST_OBITUARY_MESSAGE(context, parameter) {
    try {
      context.commit("START_LOADING");
      requestRegistObituaryMessage(parameter)
        .then(response => {
          if (
            response.data !== null &&
            response.data != undefined &&
            response.data.result === "success"
          ) {
            context.commit("OBITUARY_MESSAGE_LIST", response.data);
            router.push({ path: "/obituaryMessage" });
          } else {
            alert(response.data.message);
          }
          context.commit("END_LOADING");
        })
        .catch(error => {
          context.commit("END_LOADING");
        });
      context.commit("END_LOADING");
    } catch (e) {
      if (e === "refresh") {
        return;
      }
      context.commit("END_LOADING");
      alert(
        "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
      );
    }
  },

  async REQUEST_OBITUARY_MESSAGE_DETAIL(context, parameter) {
    try {
      context.commit("START_LOADING");
      const response = await requestObituaryMessageDetail(
        parameter.obituaryMessageId
      );
      if (
        response.data !== null &&
        response.data != undefined &&
        response.data.result === "success"
      ) {
        context.commit("OBITUARY_MESSAGE_DETAIL", response.data);
      } else {
        if (response !== "refresh") {
          alert(response.data.message);
        }
      }
      context.commit("END_LOADING");
    } catch (e) {
      if (e === "refresh") {
        return;
      }

      context.commit("END_LOADING");
      context.commit("OPEN_MODAL", {
        title: "실패",
        content: "확인해주세요.",
        option1: "닫기"
      });
      alert(
        "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
      );
    }
  },
  // new
  async REQUEST_OBITUARY_MESSAGE_LIST({ commit }, parameter) {
    try {
      commit("START_LOADING");
      const response = await requestObituaryMessageList(parameter);
      const { data } = response;
      if (data?.result !== "success") {
        return alert(data.message);
      }
      commit("OBITUARY_MESSAGE_LIST", {
        ...data,
        type: parameter.type,
        id: parameter.id
      });
    } catch (e) {
      if (e === "refresh") {
        return;
      }
      console.error(e);
      alert(
        "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
      );
    } finally {
      commit("END_LOADING");
    }
  },
  // new
  async REQUEST_UPDATE_OBITUARY_MESSAGE({ commit }, parameter) {
    try {
      commit("START_LOADING");

      const res = await requestUpdateObituaryMessage(parameter);
      const { data } = res;

      if (data?.result !== "success") {
        return alert(data.message);
      }
    } catch (e) {
      if (e === "refresh") {
        return;
      }
      console.error(e);
      alert(
        "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
      );
    } finally {
      commit("END_LOADING");
    }
  },
  // new
  async REQUEST_DELETE_OBITUARY_MESSAGE({ commit }, parameter) {
    try {
      commit("START_LOADING");
      const responseDelete = await requestDeleteObituaryMessage(
        parameter.obituaryMessageId
      );
      if (
        !(
          responseDelete.data !== null &&
          responseDelete.data != undefined &&
          responseDelete.data.result === "success"
        )
      ) {
        alert(responseDelete.data.message);
        return;
      }
    } catch (e) {
      if (e === "refresh") {
        return;
      }

      console.error(e);
      alert(
        "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
      );
    } finally {
      commit("END_LOADING");
    }
  }
};

export default { mutations, state, actions, getters };
